module.exports = __webpack_public_path__ + "img/about03.60ce05a7.png";